// extracted by mini-css-extract-plugin
export default {"plug":"plug--APB8N","title":"title--rjZzS","description":"description--X_DjQ"};